import useGlobals from './useGlobals';

interface AmplitudeDataInterface {
  [key: string]: string | number | boolean | null;
}

export type AmplitudeFunctionInterface = (
  name: string,
  data?: AmplitudeDataInterface | undefined,
) => void;

const useAmplitude = () => {
  const { amplitude } = useGlobals();

  const amplitudeEvent: AmplitudeFunctionInterface = (
    name: string,
    data?: AmplitudeDataInterface,
  ) => {
    amplitude().logEvent(name, data);
  };

  return {
    amplitudeEvent,
  };
};

export default useAmplitude;
